import React from 'react';
import "../css/Cstomer.css";
import WHatsapp from "../images/whatsapp.png";
import Skype from "../images/skype.png";
import Aisehi from "../images/Customer4.jpg";
import Customer1 from "../images/Customer1.png";
import Customer2 from "../images/Customer2.png";
import Customer3 from "../images/Customer3.png";

function Customer() {
  return (
    <>
      <div className="Customer-head">
        <img className='Customer-head-img' src={Aisehi} alt=''/>
        <div className="Customer-head-info">
        <p style={{fontSize:"42px", fontWeight:"bolder"}}>Contact us today</p>
        <p>For a Free Consultation</p>
        </div>
        <div className="Customer-head-links">
            <div className="Customer-head-link">
                <img className='Customer-link-img' src={Skype} alt=''/>
                <p>live:purohitTechnosoft</p>
            </div>
            <div className="Customer-head-link">
                <img className='Customer-link-img' src={WHatsapp} alt=''/>
                <p>+91 7891266745</p>
            </div>
        </div>
      </div>
      <div className="Customer-below">
        <p style={{fontSize:"36px",fontWeight:"bolder"}}>Know how we engage with our customers</p>
        <p>A Comprehensive Range of Web App Solutions Tailored for Every Business Need.</p>
        <div className="Customer-below-cards">
            <div className="Customer-below-card">
                <img className='Customer-card-img' src={Customer1} alt='' />
                <p style={{marginTop:"10px", fontWeight:"bolder",fontSize:"20px"}}>Knowing Our Clients</p>
                <hr className='Customer-below-card-hr'/>
                <p>Call or Meeting</p>
                <p>NDA(Non-Disclosure)</p>
            </div>
            <div className="Customer-below-card">
                <img className='Customer-card-img' src={Customer2} alt='' />
                <p style={{marginTop:"10px", fontWeight:"bolder",fontSize:"20px"}}>Project Projections</p>
                <hr className='Customer-below-card-hr'/>
                <p>Gather Requirements</p>
                <p>Perfect Proposal</p>
            </div>
            <div className="Customer-below-card">
                <img className='Customer-card-img' src={Customer3} alt='' />
                <p style={{marginTop:"10px", fontWeight:"bolder",fontSize:"20px"}}>Collaborative Partnership</p>
                <hr className='Customer-below-card-hr'/>
                <p>T&C Communicated</p>
                <p>Project Agreement</p>
            </div>
        </div>
      </div>
    </>
  )
}

export default Customer;
